import { useEffect } from 'react';
import { useModal } from '../../contexts/modal';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { setStationId } from '../../slices/local/orchestrator';
import { PlaybackIssueModal } from '../dialogs/PlaybackIssueModal';

export const PlaybackIssueWatcher = () => {
  const dispatch = useAppDispatch();
  const { showModal } = useModal();
  const notice = useAppSelector(state => state.playbackIssue.current);

  useEffect(() => {
    if (!notice) {
      return;
    }

    const { playerId, channel, stationId } = notice;
    showModal(PlaybackIssueModal, {
      onConfirm: () => {
        dispatch(setStationId({
          playerId,
          channel,
          stationId
        }));
      }
    });
  }, [notice?.id, dispatch, showModal]);

  return null;
};
